const Page404 = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-purple-200 animate-fadeIn">
      <div className="relative">
        <span className="absolute inset-0 flex items-center justify-center animate-ping text-purple-300 text-9xl font-extrabold select-none opacity-30">404</span>
        <h1 className="relative text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-blue-500 drop-shadow-lg animate-bounce">404</h1>
      </div>
      <h2 className="mt-4 text-3xl font-bold text-gray-800 animate-fadeIn delay-200">Page Not Found</h2>
      <p className="mt-2 text-lg text-gray-600 animate-fadeIn delay-300">Sorry, the page you are looking for does not exist.</p>
      <a href="/" className="mt-8 px-6 py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-lg shadow-lg hover:scale-105 transform transition-all duration-300 animate-fadeIn delay-500">Go Home</a>
      <style>{`
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(40px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 1s ease forwards;
        }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        .delay-500 { animation-delay: 0.5s; }
      `}</style>
    </div>
  );
}

export default Page404;